/*
 * @Date: 2022-07-04 17:34:53
 * @LastEditors: chuhongguang
 */
export default {
  title: '环境、社会及管治',
  desc: `秉持“让企业轻松办公”的使命，以“服务好客户”为核心，我们助力于帮助企业实现轻资产化转型，为客户真正实现降本增效。`
}